import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

const AddContributorInviteModal = ({
  open,
  onClose,
  onSave,
  organizations = [],
  existingOrgIds = [],
  loading = false,
}) => {
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("accepted");

  const statusOptions = ["accepted", "automatic", "inactive", "requested"];

  const handleSave = () => {
    if (!selectedOrgId) return;
    onSave({ organizationId: selectedOrgId, status: selectedStatus });
  };

  const handleClose = () => {
    if (loading) return;
    setSelectedOrgId("");
    setSelectedStatus("accepted");
    onClose();
  };

  const existingOrgIdSet = new Set(existingOrgIds);
  const sortedOrganizations = [...organizations]
    .filter((org) => !existingOrgIdSet.has(org.id))
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="add-contributor-invite-dialog"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        id="add-contributor-invite-dialog"
        sx={{ fontFamily: "Avenir Book, sans-serif" }}
      >
        Add Contributor
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 3 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="org-select-label">Organization</InputLabel>
            <Select
              labelId="org-select-label"
              id="org-select"
              value={selectedOrgId}
              label="Organization"
              onChange={(e) => setSelectedOrgId(e.target.value)}
              disabled={loading}
              sx={{ fontFamily: "Avenir Book, sans-serif" }}
            >
              {sortedOrganizations.map((org) => (
                <MenuItem
                  key={org.id}
                  value={org.id}
                  sx={{ fontFamily: "Avenir Book, sans-serif" }}
                >
                  {org.name || org.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel id="status-select-label">Status</InputLabel>
            <Select
              labelId="status-select-label"
              id="status-select"
              value={selectedStatus}
              label="Status"
              onChange={(e) => setSelectedStatus(e.target.value)}
              disabled={loading}
              sx={{
                fontFamily: "Avenir Book, sans-serif",
                textTransform: "capitalize",
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{
                    fontFamily: "Avenir Book, sans-serif",
                    textTransform: "capitalize",
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="primary"
          disabled={loading}
          sx={{ fontFamily: "Avenir Book, sans-serif", textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          disabled={!selectedOrgId || loading}
          sx={{ fontFamily: "Avenir Book, sans-serif", textTransform: "none" }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ mr: 1 }} />
          ) : null}
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddContributorInviteModal;
